export const BIENNIAL_SPECIFICATION_VERSION = 'EPA RCRAInfo Industry File Specification - December 2024 / 2025 cycle';

export function biennialReportingYearFromApplicationYear(year: number): number {
  return year % 2 === 0 ? year - 1 : year;
}

export function validateBiennialReportingYear(
  reportingYear: number,
  currentYear = new Date().getFullYear(),
): string | null {
  if (
    !Number.isInteger(reportingYear) ||
    reportingYear < 1989 ||
    reportingYear > currentYear ||
    reportingYear % 2 === 0
  ) {
    return 'Biennial Report reporting year must be an odd-numbered completed calendar year.';
  }
  return null;
}

export function isBiennialSourceCode(value: string): boolean {
  return /^G[0-9]{2}$/.test(value.trim().toUpperCase());
}

export function isBiennialFormCode(value: string): boolean {
  return /^W[0-9]{3}$/.test(value.trim().toUpperCase());
}

export function isBiennialOnsiteManagementMethod(value: string): boolean {
  const normalized = value.trim().toUpperCase();
  return /^H[0-9]{3}$/.test(normalized) && normalized !== 'H141';
}

export function isBiennialOffsiteManagementMethod(value: string): boolean {
  return /^[HS][0-9]{3}$/.test(value.trim().toUpperCase());
}
